module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-9-18658a7f33a7234fedeba8ae9789473e.png";